export default __webpack_public_path__ + "images/987ed9ac8cbd3ff21e6ab5f2b81f1568-vancouver_desktop.webp";